import { render } from "./start_visit_from_appointment.vue?vue&type=template&id=545e5bd0&scoped=true"
import script from "./start_visit_from_appointment.vue?vue&type=script&lang=js"
export * from "./start_visit_from_appointment.vue?vue&type=script&lang=js"

import "./start_visit_from_appointment.vue?vue&type=style&index=0&id=545e5bd0&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545e5bd0"]])

export default __exports__